import isArray from 'lodash-es/isArray';

export default (value) => {
  if (!value || !isArray(value)) return [];
  return value.slice().reverse();
};



// WEBPACK FOOTER //
// ./src/filter/reverse.js